"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nSizeKey = exports.i18nAlignmentKey = exports.i18nKey = void 0;
var i18nPrefix = 'RichTextLib.embed.';

var i18nKey = function i18nKey(key) {
  return "" + i18nPrefix + key;
};

exports.i18nKey = i18nKey;

var i18nAlignmentKey = function i18nAlignmentKey(key) {
  return i18nPrefix + "alignment." + key;
};

exports.i18nAlignmentKey = i18nAlignmentKey;

var i18nSizeKey = function i18nSizeKey(key) {
  return i18nPrefix + "size." + key;
};

exports.i18nSizeKey = i18nSizeKey;